module.exports = __webpack_public_path__ + "img/back-button.60bd583b.svg";